import React, { useState } from "react";

import { PersonalDataUpdateOcrResult } from "./PersonalDataUpdateOcrResult/PersonalDataUpdateOcrResult";
import { PersonalDataUpdateOcrUpload } from "./PersonalDataUpdateOcrUpload/PersonalDataUpdateOcrUpload";

export const PersonalDataUpdateOcr = () => {
  const [ocrState, setOcrState] = useState("Upload");
  const [ocrResult, setOcrResult] = useState({});
  const [failedOcrCount, setFailedOcrCount] = useState(0);

  return (
    <div className="text-center">
      {ocrState === "Upload" ? (
        <PersonalDataUpdateOcrUpload
          ocrResult={ocrResult}
          setOcrState={setOcrState}
          setOcrResult={setOcrResult}
          setFailedOcrCount={setFailedOcrCount}
          failedOcrCount={failedOcrCount}
        />
      ) : (
        <PersonalDataUpdateOcrResult
          ocrResult={ocrResult}
          setOcrState={setOcrState}
          setFailedOcrCount={setFailedOcrCount}
        />
      )}
    </div>
  );
};
